import { css } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"
import { commaFormat } from "@p-ban/common/src/utils/NumberUtils"

import type { ManufactureResult } from "../../../../types/parsedResult"
import COLOR_CODE from "../../../constant/color"

import initialCostLabel from "./initialCost.svg"

type Props = {
  result: ManufactureResult
}

const Cell = ({ result }: Props) => {
  const amount = result.isIndividual ? (
    "個別見積"
  ) : (
    <>
      <span className={styles.amount}>{commaFormat(result.amount)}</span>円
    </>
  )
  const unitPrice = result.isIndividual ? "ー" : `単価${commaFormat(result.unitPrice)}円`
  const initialCost = result.isIndividual ? (
    "ー"
  ) : (
    <div className={styles.initialCostContainer}>
      <Image src={initialCostLabel} width={23} height={14} alt="イニシャル費用" />
      <span>{commaFormat(result.initialCost)}円</span>
    </div>
  )
  const days = result.isIndividual ? "ー" : `${result.days}日`

  const showInitialCost = !!result.initialCost

  return (
    <div>
      <div className={styles.amountContainer}>{amount}</div>
      <div className={styles.gray}>
        <div>
          {unitPrice} / {days}
        </div>
        {showInitialCost && <div>{initialCost}</div>}
      </div>
    </div>
  )
}

export default Cell

const styles = {
  amountContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 39px;
    font-size: 13px;
  `,
  amount: css`
    font-size: 16px;
    font-weight: bold;
  `,
  gray: css`
    min-height: 20px;
    font-size: 13px;
    background-color: ${COLOR_CODE.SIMULATION_CELL_GRAY};
    border-right: 2px solid white;
    border-left: 2px solid white;
    > * {
      text-align: center;
    }
  `,
  initialCostContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  `,
}
